
import React from 'react';
import { siteConfig } from '../config/site';
import { Star, Quote } from 'lucide-react';
import { useLanguage } from '../App';

const Reviews: React.FC = () => {
  const { t } = useLanguage();
  return (
    <section id="reviews" className="relative py-20 px-6 overflow-hidden bg-primary">
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-primary via-secondary/10 to-primary"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16 reveal reveal-up">
          <h3 className="text-accent font-bold tracking-[0.3em] uppercase text-[9px] mb-3 opacity-50">{t.verifiedTestimonials}</h3>
          <h2 className="text-3xl sm:text-4xl font-serif font-bold mb-6 uppercase tracking-tight">{t.clientVoice}</h2>
          <div className="flex justify-center items-center gap-3 text-accent mb-8">
            <span className="text-2xl font-serif italic">4.9</span>
            <div className="flex text-accent/40">
              {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" className="text-accent" />)}
            </div>
            <span className="text-white/20 text-[8px] font-black uppercase tracking-widest">500+ Reviews</span>
          </div>
          <div className="w-12 h-px bg-accent/10 mx-auto"></div>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {t.reviews.map((rev: any, idx: number) => (
            <div key={idx} className="bg-black/30 backdrop-blur-sm p-8 border border-white/5 relative group hover:border-accent/20 transition-all duration-700 shadow-xl reveal reveal-up">
              <Quote className="absolute top-4 right-6 text-accent/5 w-12 h-12 group-hover:text-accent/10 transition-colors" />
              <div className="flex text-accent/40 mb-5">
                {[...Array(5)].map((_, i) => <Star key={i} size={10} fill="currentColor" />)}
              </div>
              <p className="text-white/60 italic mb-6 leading-relaxed font-light text-base">"{rev.text}"</p>
              <div className="flex items-center justify-between border-t border-white/5 pt-5">
                <span className="font-serif font-bold text-accent/80 uppercase tracking-[0.2em] text-[11px]">{rev.author}</span>
                <span className="text-[8px] text-white/20 uppercase font-black tracking-widest">{rev.date}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;
